import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

/**
 * CEDatePicker — the CE-standard date picker.
 *
 * Renders the `MobileDatePicker` dialog UNCONDITIONALLY — desktop and touch
 * devices alike. Per Amine (2026-09-30): the mobile dialog is the Portal-wide
 * standard; the Batch D desktop-popover delta was reverted immediately.
 *
 * `alwaysMobile` is a deprecated no-op — kept accepted (and stripped from the
 * spread) so the existing call sites stay untouched.
 *
 * Every other prop is passed straight through to the underlying picker.
 *
 * @param {{ alwaysMobile?: boolean }} props
 */
const CEDatePicker = ({ alwaysMobile = false, ...props }) => {
  return <MobileDatePicker {...props} />;
};

export default CEDatePicker;
